import * as React from 'react';
import axios from 'axios';
import { getCookies } from "cookies-next";

import PlusIcon from '@rsuite/icons/Plus';

import 'ckeditor5/ckeditor5.css';
import { config } from '../../data/config';
import Swal from 'sweetalert2';
import { useTranslation } from 'react-i18next';
import { Button, Input, InputGroup, List } from 'rsuite';
import TrashIcon from '@rsuite/icons/Trash';

export default function TissList({ data, reload }: any) {
    const { t } = useTranslation();
    let cookie = getCookies();

    const [newitem, setItemEdit] = React.useState(data.data === undefined ? false : true);
    const [show, setShow] = React.useState(true);
    const [list, setList] = React.useState<any[]>(data.data && data.data.list ? data.data.list : []);
    const [text, setText] = React.useState<string>('');

    const startedit = () => {
        setItemEdit(true);
        setShow(false);
    };

    const backtopreviw = () => {
        setItemEdit(true);
        setShow(true);
    };

    const AddText = () => {
        const newItem = {
            text: text,
            arrange: list.length + 1,
        };
        setList([...list, newItem]);
        setText('');
    };

    const removeItem = (index: number) => {
        const updatedList = list.filter((_, i) => i !== index).map((item, idx) => ({
            ...item,
            arrange: idx + 1,
        }));
        setList(updatedList);
    };

    const moveItem = (index: number, direction: 'up' | 'down') => {
        const newList = [...list];
        const targetIndex = direction === 'up' ? index - 1 : index + 1;

        if (targetIndex >= 0 && targetIndex < newList.length) {
            // Swap items
            [newList[index], newList[targetIndex]] = [newList[targetIndex], newList[index]];
            // Update arrange values
            newList[index].arrange = index + 1;
            newList[targetIndex].arrange = targetIndex + 1;
            setList(newList);
        }
    };

    const editItem = (index: number, newText: string) => {
        const updatedList = list.map((item, idx) => 
            idx === index ? { ...item, text: newText } : item
        );
        setList(updatedList);
    };

    const inputHandler = (event: any, editor: any) => {
        setShow(editor.getData());
    };

    const save = async () => {
        try {
            const path = `${config.url}/v1/dashboard/component/texteditor/${data._id}`;

            await axios({
                method: 'put',
                data: {
                    list: list,
                },
                url: path,
                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                },
            });
            Swal.fire('بروز شد');
        } catch (error) {
            console.error('Error saving data:', error);
        }
    };

    return (
        <div className='w-[100%] p-4' dir='rtl'>
            <InputGroup inside>
                <Input
                    value={text}
                    onChange={(e) => {
                        setText(e);
                    }}
                />
                <InputGroup.Addon>
                    <Button onClick={AddText}>
                        <PlusIcon />
                    </Button>
                </InputGroup.Addon>
            </InputGroup>
            <List size={'sm'}>
                {list.map((item, index) => (
                    <List.Item key={index} index={index}>
                        <div className='flex flex-row gap-2'>
                            <Button onClick={() => removeItem(index)}>
                                <TrashIcon />
                            </Button>
                            <Button onClick={() => moveItem(index, 'up')} disabled={index === 0}>
                                ↑
                            </Button>
                            <Button onClick={() => moveItem(index, 'down')} disabled={index === list.length - 1}>
                                ↓
                            </Button>
                            <Input
                                value={item.text}
                                onChange={(value) => editItem(index, value)}
                                style={{ width: 'auto', flex: 1 }}
                            />
                        </div>
                    </List.Item>
                ))}
            </List>
         <hr />
         <Button onClick={(e)=>{ save();}}>ذخیره سازی</Button>
        </div>
    );
}
